export enum ExportTypes {
    PDF = 1,
    Excel = 2
}